import Input from 'component/atom/forms/input/input/Input';
import Toggle from 'component/atom/forms/toggle/Toggle';
import { useFormikContext } from 'formik';
import React from 'react';
import styles from './fields.module.scss';

const EmailField = ({ index, field }) => {
  const formik = useFormikContext();

  return (
    <div className={`${styles['field']} ${styles['email']}`}>
      <Input
        label="Input Label"
        placeholder="Enter Label"
        name={`formDetails[${index}].fieldLabel`}
        value={field.fieldLabel}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={
          formik.touched?.formDetails?.[index]?.fieldLabel &&
          formik.errors?.formDetails?.[index]?.fieldLabel
        }
        touched={
          formik.touched?.formDetails?.[index]?.fieldLabel &&
          formik.errors?.formDetails?.[index]?.fieldLabel
        }
      />
      <Input
        label="Input Placeholder"
        placeholder="Enter Placeholder"
        name={`formDetails[${index}].placeHolder`}
        value={field.placeHolder}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={
          formik.touched?.formDetails?.[index]?.placeHolder &&
          formik.errors?.formDetails?.[index]?.placeHolder
        }
        touched={
          formik.touched?.formDetails?.[index]?.placeHolder &&
          formik.errors?.formDetails?.[index]?.placeHolder
        }
      />
      <div className={styles['fieldContainer']}>
        {/* <Toggle
          label="OTP"
          left={true}
          name={`formDetails[${index}].showOTP`}
          value={field.showOTP}
          onChange={(e) =>
            formik.setFieldValue(
              `formDetails[${index}].showOTP`,
              e.target.checked
            )
          }
          style={{ flexDirection: 'column' }}
        /> */}
        <Toggle
          label="Required"
          left={true}
          name={`formDetails[${index}].isMandatory`}
          value={field.isMandatory}
          onChange={(e) =>
            formik.setFieldValue(
              `formDetails[${index}].isMandatory`,
              e.target.checked
            )
          }
          style={{ flexDirection: 'column' }}
        />
      </div>
    </div>
  );
};

export default EmailField;
